// extracted by mini-css-extract-plugin
export default {"Modal":"pU8h5iowVF6HWFgS6RQL"};